module.exports = "<div ng-if=\"item()\" class=\"gw-schedule-data-item-readonly-currency\">{{ {amount: item().getValue(), currency: item().getPropertyInfo().getCurrency()} | gwCurrency }}</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/templates/currency.html
// module id = 442
// module chunks = 0